import {connect} from 'react-redux';
import React, {Component} from 'react';

import BookIt from "./BookIt";
import FbShare from "../FbShare";
import CallbackBanner from "../CallbackBanner";

class Sidebar extends Component {
    render() {
        const i18n = this.props.languages.i18n;
        return (
            <div className="sidebar">
                <BookIt/>
                <CallbackBanner btnTitle={i18n['objectPage.bookingRequest']}/>
                <FbShare/>
            </div>
        )
    }
}

const mapStateToProps = state => {
    const languages = state.languages;
    const objectPage = state.objectPage;

    return {
        languages,
        objectPage
    };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);


// WEBPACK FOOTER //
// ./src/components/PropertyPage/Rental/Sidebar.js